import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import WarningIcon from '@material-ui/icons/Warning';

export default function CertExpiryWarning({
  open,
  onClose,
  bankName,
  expirationDate,
  onRedirect,
}) {
  const [dontShowAgain, setDontShowAgain] = React.useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      // Save dismissal in localStorage with key unique to this certificate
      const dismissKey = `cert-warning-dismissed-${bankName}-${expirationDate}`;
      localStorage.setItem(dismissKey, 'true');
    }
    onClose();
  };

  const handleRedirect = () => {
    if (dontShowAgain) {
      const dismissKey = `cert-warning-dismissed-${bankName}-${expirationDate}`;
      localStorage.setItem(dismissKey, 'true');
    }
    onRedirect();
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR');
  };

  const daysUntilExpiry = () => {
    const today = new Date();
    const expiry = new Date(expirationDate);
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      BackdropProps={{
        className: '',
        style: { backgroundColor: alpha('#246E47', 0.3) },
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <WarningIcon color="error" />
        <Typography variant="h6">Certificado Expirando</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          O certificado do banco
          {' '}
          <strong>{bankName}</strong>
          {' '}
          expira em
          {' '}
          <strong>{formatDate(expirationDate)}</strong>
          {' '}
          (em
          {' '}
          <strong>
            {daysUntilExpiry()}
            {' '}
            dias
          </strong>
          ).
        </DialogContentText>
        <DialogContentText style={{ marginTop: '16px' }}>
          Renove o certificado o quanto antes para evitar interrupções nos serviços do banco.
        </DialogContentText>
        <FormControlLabel
          control={(
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              color="primary"
            />
          )}
          label="Não mostrar novamente"
          style={{ marginTop: '16px' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          Fechar
        </Button>
        <Button onClick={handleRedirect} color="primary" variant="contained">
          Configurar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
